(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('OutilDeleteController',OutilDeleteController);

    OutilDeleteController.$inject = ['$uibModalInstance', 'entity', 'Outil'];

    function OutilDeleteController($uibModalInstance, entity, Outil) {
        var vm = this;

        vm.outil = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Outil.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
